import { FC, memo } from "react";
import { useTranslation } from "react-i18next";
import { Avatar, Badge } from "@fluentui/react-components";
import { Checkmark20Filled } from "@fluentui/react-icons";
import styles from "@/components/CompanyOption/CompanyOption.module.css";
import type { CompanyOptionProps } from "@/components/CompanyOption/CompanyOption.types";

export const CompanyOption: FC<CompanyOptionProps> = memo(
  ({ name, subtitle, selected, current, onClick }) => {
    const { t } = useTranslation();

    return (
      <button
        type="button"
        role="radio"
        aria-checked={selected}
        className={selected ? styles.selectedOption : styles.option}
        onClick={onClick}
      >
        <Avatar aria-hidden name={name} color="colorful" size={32} />
        <span className={styles.text}>
          <span className={styles.name}>{name}</span>
          <span className={styles.subtitle}>{subtitle}</span>
        </span>
        <span className={styles.trailing}>
          {current && (
            <Badge appearance="tint" color="brand">
              {t("Current")}
            </Badge>
          )}
          <span className={styles.check}>
            {selected && <Checkmark20Filled />}
          </span>
        </span>
      </button>
    );
  },
);
